import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Users from './views/Users.vue';
import Stores from './views/Stores.vue';
import Do from './views/Do.vue';
import Si from './views/Si.vue';
import Doheader from './views/DoHeader.vue';
import Doitem from './views/Doitem.vue';
import Schedules from './views/Schedules.vue';
import Settings from './views/Settings.vue';
import MasterDataSettings from './views/MasterDataSettings.vue';
import InitialData from './views/InitialData.vue';
import SapData from './views/SapData.vue';
import LoadAndBillOfLoad from './views/LoadAndBillOfLoad.vue';
import Loads from './views/Loads.vue';
import BillOfLoads from './views/BillOfLoads.vue';
import BillOfLoadProblems from './views/BillOfLoadProblems.vue';
import Ccic from './views/Ccic.vue';
import CcicApplication from './views/CcicApplication.vue';
import CcicContainer from './views/CcicContainer.vue';
import CcicPunch from './views/CcicPunch.vue';
import LoadList from './views/LoadList.vue';
import LoadListNew from './views/LoadListNew.vue';
import CallLog from './views/CallLog.vue';
import YardQc from './views/YardQc.vue';
import DownloadApp from './views/DownloadApp.vue';
import Dispatch from './views/Dispatch.vue';
import YardExport from './views/YardExport.vue';
import DirectExport from './views/DirectExport.vue';
import Import from './views/Import.vue';
import TruckLoad from './views/TruckLoad.vue';
import cockpit from './views/Cockpit.vue';
import Driver from './views/Driver.vue';
import cockpitStage from './views/CockpitStage.vue';
import cockpitLoad from './views/CockpitLoad.vue';
import GSTLoadAndStage from './views/GSTLoadAndStage.vue';
import GSTload from './views/GSTload.vue';
import GSTstage from './views/GSTstage.vue';
import Price from './views/GSTPrice.vue';
import PriceMaint from './views/GSTPriceMaint.vue';
import GSTDriverMaster from './views/GSTDriverMaster.vue';
import FSIOperationCockpit from './views/FSIoperationCockpit.vue';
import InboundCockpitNew from './views/FSIoperationCockpitInbound.vue';
import OutboundCockpitNew from './views/FSIoperationCockpitoutbound.vue';
import Inbound from './views/Inbound.vue'
import Outbound from './views/Outbound.vue'
import OutboundCockpit from './views/OutboundCockpit.vue'
import InboundCockpitAppt from './views/InboundCockpitAppt.vue'
import InboundCockpitScale from './views/InboundCockpitCheckIn.vue'
import InboundCockpitTM from './views/InboundCockpitTM.vue'
import OutboundList from './views/OutboundList.vue'
import SmsInLog from './views/STCSMSLog.vue'
import MasterDataApp from './views/MasterDataApp'
import MasterDataTemplateApp from './views/MasterDataTemplateApp'
import MasterDataYG from './views/MasterDataYG'
import MasterDataCarrier from './views/MasterDataCarrier'
import MasterDataChassisVendor from './views/MasterDataChassisVendor'
import MasterDataCustomer from './views/MasterDataCustomer'
import MasterDataDriverCompany from './views/MasterDataDriverCompany'
import MasterDataLeaseChassis from './views/MasterDataLeaseChassis'
import MasterDataLocation from './views/MasterDataLocation'
import MasterDataTruck from './views/MasterDataTruck'
import MasterDataDriver from './views/MasterDataDriver'
//import IBSList from './views/IBSList.vue';
//import IBSInbound from './views/IBSInbound.vue';
import IBSList from './views/IBSList_old.vue';
import IBSInbound from './views/IBSInbound_old.vue';
import IBSInbound3rdParty from './views/IBSInboundFor3rdParty.vue'
import IBSOutbound from './views/IBSOutbound.vue';
import DriverMaster from './views/DriverMaster.vue';
import FSIDriverMaster from './views/FSIDriverMaster.vue';
import DriverSMS from './views/DriverSMS.vue';
import CCRLog from './views/CCRLog.vue';
import FSIDailyreport from  './views/FSIDailyreport.vue'
import FSIDailyreportInbound from './views/FSIDailyreportInbound.vue';
import FSIDailyreportNoshow from './views/FSIDailyreportNoshow.vue';
import FSIDailyreportDetention from './views/FSIDailyreportDetention.vue';
import FSIDailyreportProgress from './views/FSIDailyreportProgress.vue';
import DispatchLoad from './views/DispatchLoad.vue';
import DispatchStage from './views/DispatchStage.vue';
import Confirm from './views/Confirm.vue';
// import ConfirmLoad from './views/ConfirmLoad.vue';
// import ConfirmLoadDetail from './views/ConfirmLoadDetail.vue';
import ConfirmStage from './views/ConfirmStage.vue';
import ConfirmStageDetail from './views/ConfirmStageDetail.vue';
import ConfirmAPARLoad from './views/ConfirmAPARLoad.vue';
import ConfirmAPARLoadDetail from './views/ConfirmAPARLoadDetail.vue';
import ConfirmAPARStage from './views/ConfirmAPARStage.vue';
import ConfirmAPARStageDetail from './views/ConfirmAPARStageDetail.vue';
import ConfirmAPARStageMass from './views/ConfirmAPARStageMass.vue';
import LockAPAR from './views/Lock.vue';
import LockAPARLoad from './views/LockLoad.vue';
import LockAPARStage from './views/LockStage.vue';
import LockAPARChassis from './views/LockChassis.vue';
import DriverGroupData from './views/DriverGroupData.vue';
import Payroll from './views/Payroll.vue';
import PayrollSettle from './views/PayrollSettle.vue';
import PayrollReport from './views/PayrollReport.vue';
import Version from './views/Version.vue';
import VersionApp from './views/VersionApp.vue';
import VersionWeb from './views/VersionWeb.vue';
import ScaleControl from './views/ScaleControl.vue';
import ScaleControlo from './views/ScaleControlo.vue';
import ScaleControli from './views/ScaleControli.vue';
import InboundUnmatchRpt from './views/FSIUnMatchRecWinRpt.vue';
import UserSettings from './views/UserSettings.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/downloadApp',
      name: 'DownloadApp',
      component: DownloadApp,
    },
    {
      path: '/pricemaint',
      name: 'PriceMaint',
      component: PriceMaint,
    },

    {
      path: '/users',
      name: 'Users',
      component: Users,
    },

    {
      path: '/version',
      name: 'Version Control',
      component: Version,
      children: [
        {
          path: 'web',
          name: 'Web',
          component: VersionWeb,
        },
        {
          path: 'app',
          name: 'App',
          component: VersionApp,
        },
      ],
    },

    {
      path: '/scalecontrol',
      name: 'Scale Control',
      component: ScaleControl,
      children: [
        {
          path: 'out',
          name: 'Scale Outbound',
          component: ScaleControlo,
        },
        {
          path: 'in',
          name: 'Scale Inbound',
          component: ScaleControli,
        },
      ],
    },


    {
      path: '/ccrlog',
      name: 'CCR Log',
      component: CCRLog,
    },

    {
      path: '/priceMangement',
      name: 'Price Management',
      component: Price,
    },

    {
      path: '/stores',
      name: 'Store Remark and Special Status',
      component: Stores,
    },

    {
      path: '/ibslist',
      name: 'IBS List',
      component: IBSList,
      children: [
        {
          path: 'ibsinbound',
          name: 'Inbound IBS',
          component: IBSInbound,
        },
        {
          path: 'ibsoutbound',
          name: 'Outbound IBS',
          component: IBSOutbound,
        },
      ],

    },

    {
      path: '/ibslist3rdparty',
      name: '3rd Party IBS Cockpit',
      component: IBSInbound3rdParty,
    },

    {
      path: '/FSIDailyreport',
      name: 'FSI Daily Progress Report',
      component: FSIDailyreport,
      children: [
        {
          path: 'FSIDailyreportInbound',
          name: 'Inbound Report',
          component: FSIDailyreportInbound,
        },
        {
          path: 'FSIDailyreportNoshow',
          name: 'No show Report',
          component: FSIDailyreportNoshow,
        },
        {
          path: 'FSIDailyreportDetention',
          name: 'Detention Report',
          component: FSIDailyreportDetention,
        },
        {
          path: 'FSIDailyreportProgress',
          name: 'Daily Progress Report',
          component: FSIDailyreportProgress,
        },
      ],

    },

    {
      path: '/do',
      name: 'DeliveryOrder',
      component: Do,
      children: [
        {
          path: 'headers',
          name: 'Header',
          component: Doheader,
        },
        {
          path: 'items',
          name: 'Item',
          component: Doitem,
        },
      ],
    },

    {
      path: '/si',
      name: 'ShippingInstruction',
      component: Si,
      children: [
        {
          path: 'headers',
          name: 'Header',
          component: Doheader,
        },
        {
          path: 'items',
          name: 'Item',
          component: Doitem,
        },
      ],
    },    

    {
      path: '/schedules',
      name: 'Schedules',
      component: Schedules,
    },
    {
      path: '/callLog',
      name: 'CallLog',
      component: CallLog,
    },
    {
      path: '/yardQc',
      name: 'YardQc',
      component: YardQc,
    },

    {
      path: '/loadListOld',
      name: 'CONTAINER/LOAD LIST',
      component: LoadList,
    },

    {
      path: '/loadList',
      name: 'CONTAINER/LOAD LIST',
      component: LoadListNew,
    },


    {
      path: '/dispatch',
      name: 'Dispatch',
      component: Dispatch,
      children: [
        {
          path: 'load',
          name: 'Load',
          component: DispatchLoad,
        },
        {
          path: 'stage',
          name: 'Stage',
          component: DispatchStage,
        },
        {
          path: 'cockpit',
          name: 'cockpit',
          component: cockpit,
        },
      ],
    },

    {
      path: '/confirm',
      name: 'Maintain',
      component: Confirm,
      children: [
        // {
        //   path: 'load',
        //   name: 'Load',
        //   component: ConfirmLoad,
        // },
        // {
        //   path: 'confirmloaddetail',
        //   name: 'Load Detail',
        //   component: ConfirmLoadDetail,
        // },
        // {
        //   path: 'stage',
        //   name: 'Load/Stage',
        //   component: ConfirmStage,
        // },
        // {
        //   path: 'confirmstagedetail',
        //   name: 'Load/Stage Detail',
        //   component: ConfirmStageDetail,
        // },
        {
          path: 'aparload',
          name: 'Load Billing',
          component: ConfirmAPARLoad,
        },
        {
          path: 'confirmaparloaddetail',
          name: 'Load Billing Detail',
          component: ConfirmAPARLoadDetail,
        },
 
        {
          path: 'aparstage',
          name: 'Stage Cost',
          component: ConfirmAPARStage,
        },
        {
          path: 'confirmaparstagedetail',
          name: 'Stage Cost Detail',
          component: ConfirmAPARStageDetail,
        },
        {
          path: 'aparstagemass',
          name: 'Stage Cost(Mass)',
          component: ConfirmAPARStageMass,
        },        
      ],
    },

    {
      path: '/payroll',
      name: 'Driver Payroll',
      component: Payroll,
      children: [
        {
          path: 'settlement',
          name: 'Settlement',
          component: PayrollSettle,
        },
        {
          path: 'report',
          name: 'Report',
          component: PayrollReport,
        },

      ],
    },

    {
      path: '/lock',
      name: 'Lock',
      component: LockAPAR,
      children: [
        {
          path: 'load',
          name: 'Load',
          component: LockAPARLoad,
        },
        {
          path: 'stage',
          name: 'Stage',
          component: LockAPARStage,
        },
        {
          path: 'chassis',
          name: 'Report',
          component: LockAPARChassis,
        },
      ],
    },
    
    {
      path: '/gstLoadAndStage',
      name: 'Load & Stage',
      component: GSTLoadAndStage,
      children: [
        {
          path: 'gstLoads',
          name: 'LOAD',
          component: GSTload,
        },
        {
          path: 'gstStages',
          name: 'Stage',
          component: GSTstage,
        },
        {
          path: 'cockpitStage',
          name: 'cockpitStage',
          component: cockpitStage,
        },
        {
          path: 'cockpitLoad',
          name: 'cockpitLoad',
          component: cockpitLoad,
        },
      ],
    },


    {
      path: '/fsiOperationCockpit',
      name: 'FSI Operation Cockpit',
      component: FSIOperationCockpit,
      children: [
        {
          path: 'inbound',
          name: 'Inbound',
          component: Inbound,
        },
        {
          path: 'outbound',
          name: 'Outbound',
          component: Outbound,
        },
        {
          path: 'outboundList',
          name: 'OutboundList',
          component: OutboundList,
        },
        {
          path: 'ocReports',
          name: 'Reports',
          component: InboundUnmatchRpt,
        },
        {
          path: 'stcsmslog',
          name: 'SMS Detail Log',
          component: SmsInLog,
        },
        
      ],
    },

    {
      path: '/inboundCockpitNew',
      name: 'Inbound Cockpit',
      component: InboundCockpitNew,
      children: [
        {
          path: 'inboundAppt',
          name: 'Inbound Appointments',
          component: InboundCockpitAppt,
        },
        {
          path: 'inboundScale',
          name: 'Inbound Check In & Data Management',
          component: InboundCockpitScale,
        },
        {
          path: 'inboundTM',
          name: 'Inbound Scaling & Ticket Management',
          component: InboundCockpitTM,
        },
        // {
        //   path: 'outboundCockpit',
        //   name: 'Outbound Cockpit',
        //   component: OutboundCockpit,
        // },
        // {
        //   path: 'outboundList',
        //   name: 'OutboundList',
        //   component: OutboundList,
        // },
        {
          path: 'ocReports',
          name: 'Reports',
          component: InboundUnmatchRpt,
        },
        // {
        //   path: 'stcsmslog',
        //   name: 'SMS Detail Log',
        //   component: SmsInLog,
        // },
        
      ],
    },

    {
      path: '/outboundCockpitNew',
      name: 'Outbound Cockpit',
      component: OutboundCockpitNew,
      children: [
        // {
        //   path: 'inboundAppt',
        //   name: 'Inbound Appointments',
        //   component: InboundCockpitAppt,
        // },
        // {
        //   path: 'inboundScale',
        //   name: 'Inbound Check In & Data Management',
        //   component: InboundCockpitScale,
        // },
        // {
        //   path: 'inboundTM',
        //   name: 'Inbound Scaling & Ticket Management',
        //   component: InboundCockpitTM,
        // },
        {
          path: 'outboundCockpit',
          name: 'Outbound Cockpit',
          component: OutboundCockpit,
        },
        {
          path: 'outboundList',
          name: 'OutboundList',
          component: OutboundList,
        },
        // {
        //   path: 'ocReports',
        //   name: 'Reports',
        //   component: InboundUnmatchRpt,
        // },
        // {
        //   path: 'stcsmslog',
        //   name: 'SMS Detail Log',
        //   component: SmsInLog,
        // },
        
      ],
    },

    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
      children: [
        {
          path: 'masterData',
          name: 'MasterData',
          component: MasterDataSettings,
        },
        {
          path: 'driverMaster',
          name: 'DriverMaster',
          component: DriverMaster,
        },
        {
          path: 'initialData',
          name: 'InitialData',
          component: InitialData,
        },
        {
          path: 'sapData',
          name: 'sapData',
          component: SapData,
        },
      ],
    },
    {
      path: '/driver',
      name: 'Driver',
      component: Driver,
    },
    {
      path: '/driverSMS',
      name: 'DriverSMS',
      component: DriverSMS,
    },
    {
      path: '/loadAndBillOfLoad',
      name: 'Load & BOL',
      component: LoadAndBillOfLoad,
      children: [
        {
          path: 'loads',
          name: 'Load',
          component: Loads,
        },
        {
          path: 'billOfLoads',
          name: 'BOL',
          component: BillOfLoads,
        },
        {
          path: 'billOfLoadProblems',
          name: 'BOL Problem & Photo',
          component: BillOfLoadProblems,
        },
      ],
    },
    {
      path: '/ccic',
      name: 'CCIC',
      component: Ccic,
      children: [
        {
          path: 'applications',
          name: 'IBD',
          component: CcicApplication,
        },
        {
          path: 'containers',
          name: 'Container',
          component: CcicContainer,
        },

        // {
        //   path: 'punchs',
        //   name: 'CCICPunchs',
        //   component: CcicPunch,
        // },



        // {
        //   path: 'reminder',
        //   name: 'CCICReminder',
        //   component: CcicReminder,
        // },
      ],
    },

    {
      path: '/outboundCockpit',
      name: 'Outbound Cockpit',
      component: OutboundCockpit,
    },

    {
      path: '/inboundCockpitAppt',
      name: 'Inbound Cockpit Appointments',
      component: InboundCockpitAppt,
    },

    {
      path: '/inboundCockpitScale',
      name: 'Inbound Cockpit Scaling',
      component: InboundCockpitScale,
    },

    {
      path: '/inboundCockpitTM',
      name: 'Inbound Cockpit Ticket Mgt',
      component: InboundCockpitTM,
    },

    {
       path: '/UserSettings',
       name: 'User Settings',
       component: UserSettings,
    },

    {
      path: '/masterDataApp',
      name: 'AppointmentMaster',
      component: MasterDataApp,
    },
    {
      path: '/masterDataTemplateApp',
      name: 'TemplateAppointmentMaster',
      component: MasterDataTemplateApp,
    },
    {
      path: '/masterDataYG',
      name: 'YardGoatMaster',
      component: MasterDataYG,
    },
    {
      path: '/masterDataCarrier',
      name: 'CarrierMaster',
      component: MasterDataCarrier,
    },
    {
      path: '/masterDataChassisVendor',
      name: 'ChassisVendorMaster',
      component: MasterDataChassisVendor,
    },
    {
      path: '/masterDataDriverCompany',
      name: 'DriverCompanyMaster',
      component: MasterDataDriverCompany,
    },
    {
      path: '/masterDataCustomer',
      name: 'CustomerMaster',
      component: MasterDataCustomer,
    },
    {
      path: '/masterDataLeaseChassis',
      name: 'LeaseChassisMaster',
      component: MasterDataLeaseChassis,
    },
    {
      path: '/masterDataLocation',
      name: 'LocationMaster',
      component: MasterDataLocation,
    },
    {
      path: '/masterDataTruck',
      name: 'TruckMaster',
      component: MasterDataTruck,
    },
    {
      path: '/masterDataDriver',
      name: 'DriverMaster',
      component: MasterDataDriver,
    },
    {
      path: '/driverMaster',
      name: 'DriverMaster',
      component: DriverMaster,
    },
    {
      path: '/FSIdriverMaster',
      name: 'FSIDriverMaster',
      component: FSIDriverMaster,
    },
    {
      path: '/driverGroupData',
      name: 'DriverGroup',
      component: DriverGroupData,
    },
    
    







  ],
});
